module.exports = __webpack_public_path__ + "img/NY_LOGOTYPE.491e9ab0.jpg";